import { render, staticRenderFns } from "./ResultScreen.vue?vue&type=template&id=38625f26&scoped=true&lang=pug&"
import script from "./ResultScreen.vue?vue&type=script&lang=js&"
export * from "./ResultScreen.vue?vue&type=script&lang=js&"
import style0 from "./ResultScreen.vue?vue&type=style&index=0&id=38625f26&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38625f26",
  null
  
)

export default component.exports